import React, { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import PromoPopup from "./PromoPopup";
import MpstuntsPopup from "./MpstuntsPopup";
import GlobalLocalBusiness from "./GlobalLocalBusiness";

export default function Layout({ children }) {
    const location = useLocation();
    const isHome = location.pathname === "/";

    // When leaving the Home route, force --banner-h back to 0 synchronously
    // (before paint) so the Navbar snaps to top:0 on non-Home pages.
    useLayoutEffect(() => {
        if (!isHome) {
            document.documentElement.style.setProperty("--banner-h", "0px");
        }
    }, [isHome]);

    return (
        <div className="min-h-screen flex flex-col bg-[#F2EDE2] text-[#262422]">
            <GlobalLocalBusiness />
            <Navbar />
            <main className={`flex-1 ${isHome ? "" : "pt-24"}`}>{children}</main>
            <Footer />
            <MpstuntsPopup />
            <PromoPopup />
        </div>
    );
}
